import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(() => ({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xxs,
  },
  infoContainer: {
    flex: 1,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: spacing.s,
    paddingVertical: spacing.xs,
  },
  rowLabel: {
    flexShrink: 1,
  },
  addressContainer: {
    gap: spacing.xxs,
    alignItems: 'flex-end',
    flexGrow: 1,
  },
  tooltipRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xxs / 2,
    flexWrap: 'wrap',
  },
  tooltipContent: {
    maxWidth: 250,
    padding: spacing.xxs,
  },
  addressInfo: {
    flexDirection: 'row',
    alignItems: 'baseline',
    gap: spacing.xxs / 2,
  },
}));
